/* @flow */

import {useQuery} from '@apollo/react-hooks';
import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetCallActivity as GetCallActivityQuery,
    GetCallActivityVariables,
    GetCallActivity_activity as Activity,
} from 'nutshell-graphql-types';

import GET_CALL_ACTIVITY from '../queries/get-call-activity.graphql';

export const useGetCallActivity = (
    activityId: ?string
): ({
    activity: ?Activity,
    isLoading: boolean,
    error: ?string,
    refetch: () => Promise<*>,
    startPolling: (number) => void,
    stopPolling: () => void,
}) => {
    const {loading, data, error, refetch, startPolling, stopPolling} = useQuery<
        GetCallActivityQuery,
        GetCallActivityVariables,
    >(GET_CALL_ACTIVITY, {
        variables: {
            // $FlowIgnore no id is covered by skip
            activityId,
        },
        skip: !activityId,
    });

    const activity = data ? data.activity : null;

    return {
        activity,
        isLoading: loading,
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
        startPolling,
        stopPolling,
    };
};
